var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowHeader = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82426 4.7773C9.05858 5.01161 9.05858 5.39151 8.82426 5.62583L5.04853 9.40156H16.4C16.7314 9.40156 17 9.67019 17 10.0016C17 10.3329 16.7314 10.6016 16.4 10.6016H5.04853L8.82426 14.3773C9.05858 14.6116 9.05858 14.9915 8.82426 15.2258C8.58995 15.4601 8.21005 15.4601 7.97574 15.2258L3.17574 10.4258C2.94142 10.1915 2.94142 9.81161 3.17574 9.5773L7.97574 4.7773C8.21005 4.54298 8.58995 4.54298 8.82426 4.7773Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowHeader, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ArrowHeader.093e5a65.svg";
export { ForwardRef as ReactComponent };